import styled from 'styled-components';
import { Link } from 'react-router-dom'
import { palette } from 'styled-theme';

export const StyledLink = styled(Link)`
  color: ${palette('primary', 0)};
  :hover{
    color: ${palette('primary',1)};
  }
`